
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.741 15.556a.53.53 0 00.472.087A7 7 0 108.562 6.25a5 5 0 10-2.029 9.73.52.52 0 00.4-.154 3.03 3.03 0 011.57-.783c.272-.046.497-.266.497-.542V13a3 3 0 116 0v1.5c0 .276.225.496.498.541.44.074.865.246 1.243.515z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.707 17.293a1 1 0 00-1.414 1.414l3 3c.194.195.45.292.704.293h.006a.996.996 0 00.704-.293l3-3a1 1 0 00-1.414-1.414L13 18.586V13a1 1 0 10-2 0v5.586l-1.293-1.293z"}})])
          )
        }
      }
    